import React from "react";
import { Paper, Tabs, Tab, Divider } from "@mui/material";
import PDCAKanban from "./tabViews/PDCAKanban";
import IdeaList from "./tabViews/IdeaList";
import ArchivedProjects from "./tabViews/ArchivedProjects";
import CIMetrics from "./tabViews/CIMetrics";

// Ensure these components are correctly exported from their respective files.

export default function DashboardTabs({ tabIndex, setTabIndex }) {
  return (
    <Paper elevation={0} sx={{ padding: 3 }}>
      <Tabs
        value={tabIndex}
        onChange={(e, newIndex) => setTabIndex(newIndex)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          "& .MuiTab-root": {
            color: "#4F46E5",
          },
          "& .MuiTabs-indicator": {
            backgroundColor: "#4F46E5",
          },
          "& .MuiTab-textColorInherit": {
            color: "#4F46E5",
          },
          mb: 2,
        }}
      >
        <Tab label="CI Metrics and Charts" />
        <Tab label="Submitted Ideas" />
        <Tab label="Completed/Archived Projects" />
        <Tab label="Active Improvements" />
      </Tabs>
      <Divider sx={{ mb: 2 }} />

      {tabIndex === 0 && <CIMetrics />}
      {tabIndex === 1 && <IdeaList />}
      {tabIndex === 2 && <ArchivedProjects />}
      {tabIndex === 3 && <PDCAKanban />}
    </Paper>
  );
}
